import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

const base = "/api/admin/subscriptions";

export const getSubscriptions = createAction(
  "GET_SUBSCRIPTIONS",
  ({ payload, params }: SagaActionParams<Type.SubscriptionDto[]>) => ({
    payload,
    url: base + (params ? params : ""),
  })
);
export const getSubscriptionStats = createAction(
  "GET_SUBSCRIPTION_STATS",
  ({ payload }: SagaActionParams<Type.SubscriptionStatsDto>) => ({
    payload,
    url: base + "/stats",
  })
);
export const createSubscription = createAction(
  "CREATE_SUBSCRIPTION",
  ({ payload, body }: SagaActionParams<Type.SubscriptionDto>) => ({
    payload,
    url: base,
    body,
  })
);
export const updateSubscription = createAction(
  "UPDATE_SUBSCRIPTION",
  ({ payload, id, body }: SagaActionParams<Type.SubscriptionDto>) => ({
    payload,
    url: base + "/" + id,
    body,
  })
);
export const deleteSubscription = createAction(
  "DELETE_SUBSCRIPTION",
  ({ payload, id }: SagaActionParams<Type.SubscriptionDto>) => ({
    payload,
    url: base + "/" + id,
  })
);
export const getCampaigns = createAction(
  "GET_CAMPAIGNS",
  ({ payload }: SagaActionParams<Type.CampaignDto[]>) => ({
    payload,
    url: base + "/campaigns",
  })
);
export const sendCampaign = createAction(
  "SEND_CAMPAIGN",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: base + "/campaign",
    body,
  })
);

const subscriptionsSaga = [
  takeLatest<any>(getSubscriptions.toString(), (p: SagaGenericParams<Type.SubscriptionDto[]>) => getSaga<Type.SubscriptionDto[]>(p)),
  takeLatest<any>(getSubscriptionStats.toString(), (p: SagaGenericParams<Type.SubscriptionStatsDto>) => getSaga<Type.SubscriptionStatsDto>(p)),
  takeLatest<any>(createSubscription.toString(), (p: SagaGenericParams<Type.SubscriptionDto>) => postSaga<Type.SubscriptionDto>(p)),
  takeLatest<any>(updateSubscription.toString(), (p: SagaGenericParams<Type.SubscriptionDto>) => putSaga<Type.SubscriptionDto>(p)),
  takeLatest<any>(deleteSubscription.toString(), (p: SagaGenericParams<any>) => deleteSaga<Type.SubscriptionDto>(p)),
  takeLatest<any>(getCampaigns.toString(), (p: SagaGenericParams<Type.CampaignDto[]>) => getSaga<Type.CampaignDto[]>(p)),
  takeLatest<any>(sendCampaign.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
];

export default subscriptionsSaga;
